<template>

	<toolbar>
		<h2 v-if='heading'><i class="fa fa-clock"></i> {{heading}}</h2>
		<slot></slot>
		
		<div class="controls">
			<button 
				class="btn btn-success"
				v-on:click="newTimeLogRecord('clockIn')">
				<i class="fa fa-clock"></i>
				Clock User In/Out
			</button>

			<button 
				class="btn btn-success"
				v-on:click="newTimeLogRecord('retro')">
				<i class="fa fa-plus"></i>
				Time Log Record
			</button>

			<nav-tabs :tabs="tabs"></nav-tabs>
		</div>

		<time-log-manual-entry-modal
			:title="timeLogModal.title" 
			:visible="timeLogModal.visible"
			:record-type="timeLogModal.recordType"
			:clock-in="timeLogModal.clockIn"
			v-on:closeModal="timeLogModal.visible = false">
		</time-log-manual-entry-modal>
	</toolbar>

</template>

<script>
import Toolbar from "@/layout_fragments/Toolbar"
import NavTabs from "@/layout_fragments/NavTabs"
import TimeLogManualEntryModal from "@/components/super_components/TimeLogManualEntryModal"

export default {

	name: 'TimeLogsToolbar',
	components: {
		Toolbar,
		NavTabs,
		TimeLogManualEntryModal
	},
	props: ["heading"],
	data() {
		return {
			timeLogModal: {
				visible: false,
				clockIn: false,
				recordType: "clockIn",
				title: "Clock User In/Out"
			},
			timeLogSetting: {},
			tabs: [
				{
					label: "Review",
					icon: "fa-eye",
					path: "/time-logs/review",
				},
				{
					label: "Pay Period Reports",
					icon: "fa-table",
					path: "/time-logs/history",
					modulePermRequired: ["TimeLogs"]
				},
				/*{
					label: "Processed Logs",
					icon: "fa-clock",
					path: "/time-logs/processed",
					modulePermRequired: ["TimeLogs"]
				},*/
				{
					label: "List",
					icon: "fa-list",
					path: "/time-logs/list",
					modulePermRequired: ["TimeLogs"]
				},
				{
					label: "",
					icon: "fa-cog",
					path: "/time-logs/settings",
					modulePermRequired: ["Settings","TimeLogs"]
				}
			]
		}
	},
	methods: {
		newTimeLogRecord(type) {
			this.timeLogModal.visible = true
			this.timeLogModal.record = {}
			this.timeLogModal.recordType = type

			if (type == "clockIn") 
				this.timeLogModal.title = "Clock User In/Out"

			else
				this.timeLogModal.title = "Create a Time log"

			this.fetchData()
		},
		fetchData() {
			let promises = [
				this.getJSON("TimeLogSetting/get"),
				this.fetchUsers([],false,["first_name","last_name","email"])
			]

			let vm = this

			//this.spinner(true)

			Promise.all(promises).then(responses => {
				//vm.spinner(false)

				vm.$store.timeLogSettings = responses[0].data[0]
			})
		}
	}
}
</script>
